module.exports = __webpack_public_path__ + "media/images/box_sizes/K-fd69b5f3b9c94eef44fcf42cb2fef46d.jpg";